import React from 'react';
import { BookOpen } from 'lucide-react';
import type { ReadAnalysisWidgetData } from '../../../types/agentWidgets';

interface Props {
  data: ReadAnalysisWidgetData;
}

export const ReadAnalysisWidget: React.FC<Props> = ({ data }) => {
  return (
    <div className="mt-1.5 flex items-center gap-2 text-[11px] bg-purple-50/70 dark:bg-purple-900/10 rounded px-2 py-1.5">
      <BookOpen className="h-3 w-3 text-purple-500 dark:text-purple-400 flex-shrink-0" />
      <span className="font-medium text-purple-700 dark:text-purple-300 truncate flex-1 min-w-0">
        {data.objectiveName}
      </span>
      <span className="text-[10px] text-gray-400 dark:text-gray-500 whitespace-nowrap">
        {data.objectiveType.replace(/_/g, ' ').toLowerCase()}
      </span>
    </div>
  );
};
